import { InlineNotification, Modal, ModalProps } from '@carbon/react';
import style from './destroy-confirmation.module.scss';
import ReactDOM from 'react-dom';
interface DestroyConfirmationProps extends ModalProps {
  error?: string;
  modalHeading?: string;
  children?: React.ReactNode;
}

const DestroyConfirmation = ({
  open,
  onRequestSubmit,
  onRequestClose,
  error,
  modalHeading,
  children,
  ...rest
}: DestroyConfirmationProps) => {
  return ReactDOM.createPortal(
    <Modal
      open={open}
      modalHeading={modalHeading || 'Are you sure you want to delete this?'}
      danger
      primaryButtonText="Yes, delete"
      secondaryButtonText="No, cancel"
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      {...rest}
    >
      {error ? (
        <InlineNotification
          aria-label="closes notification"
          kind="error"
          statusIconDescription="notification"
          title={error}
          subtitle={'Please try again!'}
          hideCloseButton
          className={style.customNotification}
        />
      ) : children ? (
        children
      ) : (
        'It will be removed immediately. You can’t undo this action.'
      )}
    </Modal>,
    document.body
  );
};

export { DestroyConfirmation };
